import { EXECUTION_TYPE } from "graphql/generated/enums";
import { statusLabels } from "utils/utils";
import { StringValues, ValueLabelPair } from "./interfaces";

export const fieldOperationMapping: StringValues = {
    name: "like",
    project_id: "in",
    modified_by: "in",
    created_by: "in",
    resource_type: "in",
    activity_type: "in",
    status: "in",
    created_at_gt: "gt",
    created_at_lt: "lt",
    modified_at_gt: "gt",
    modified_at_lt: "lt",
    identity_type: "in",
    no_parent_id: "unset",
    recordLogType: "in",
    recordLogName: "like",
    subjectOrData: "like",
    execution_type: "in",
    level: "in",
};

export const fieldProps = { isReadOnly: false };

export const fieldAttr = { disabled: false };

const getStatusList = () => {
    const statusList: { notEnded: ValueLabelPair[]; ended: ValueLabelPair[] } = {
        notEnded: [],
        ended: [],
    };
    for (const status in statusLabels) {
        if (status.includes("ENDED")) {
            statusList.ended.push({
                value: status,
                label: statusLabels[status as keyof typeof statusLabels],
            });
        } else {
            statusList.notEnded.push({
                value: status,
                label: statusLabels[status as keyof typeof statusLabels],
            });
        }
    }
    return statusList;
};

// Translate a backend execution-status enum value (e.g. "AT_ENGINE") into its
// human display label (e.g. "Running") for the selected-filter chips, so the
// chip matches the label shown in the Status dropdown. Falls back to the raw
// value for any status without a mapping. FilterChipContainer upper-cases the
// result before rendering.
export const getStatusChipLabel = (status: string): string =>
    statusLabels[status as keyof typeof statusLabels] ?? status;

export const statusList = getStatusList();
export const endedStatusArray = statusList.ended.map(({ value }) => value);
export const notEndedStatusArray = statusList.notEnded.map(({ value }) => value);
export const totalEndedStatusesCount = endedStatusArray.length;
export const totalNotEndedStatusesCount = notEndedStatusArray.length;
export const totalStatusesCount = totalEndedStatusesCount + totalNotEndedStatusesCount;
export const initialExecutionStatus = [...endedStatusArray, ...notEndedStatusArray];

export const executionTypes = EXECUTION_TYPE.map((type) => type.toLowerCase());

export const baseExecutionFilter = [
    {
        field: "status",
        op: "in",
        value: initialExecutionStatus,
    },
    {
        field: "execution_type",
        op: "in",
        value: executionTypes,
    },
];
